import { createSlice } from "@reduxjs/toolkit";
import type { TemplateModel } from "../../../models/template";

const initialState = {
  loading: false,
  data: null as TemplateModel | null,
  error: null,
};

const dataSlice = createSlice({
  name: "get-model-by-id",
  initialState: initialState,
  reducers: {
    initGetModelById: () => {
      return { ...initialState };
    },
    startGetModelById: (state) => {
      state.loading = true;
    },
    successGetModelById: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorGetModelById: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initGetModelById,
  startGetModelById,
  successGetModelById,
  errorGetModelById,
} = dataSlice.actions;

export default dataSlice.reducer;
